

// Magic number to avoid plugin crashes through a settimeout call
module.exports = 3000;



// WEBPACK FOOTER //
// ./src/js/otplugin/empiric_delay.js